import { Pipe, PipeTransform } from '@angular/core';
import { BookingStatus, TripStatus } from '../../library/constants';
// import { BookingStatus, TripStatus } from '../../../../../shared/src/import-export';


@Pipe({
  name: 'tripStatusPipe',
  standalone: true,
})
export class TripStatusPipe implements PipeTransform {
  transform(value: TripStatus): string {
    // Sanitize the HTML content using DomSanitizer
    switch (value) {
      case TripStatus.created:
        return 'tripCreated';
      case TripStatus.started:
        return 'tripStarted';
      case TripStatus.ended:
        return 'tripEnded';
      case TripStatus.driverSubmitted:
        return 'tripDriverSubmitted';
      default:
        return 'tripCreated';
    }
  }
}
@Pipe({
  name: 'tripStatusBGPipe',
  standalone: true,
})
export class TripStatusBGPipe implements PipeTransform {
  transform(value: TripStatus): string {
    // Sanitize the HTML content using DomSanitizer
    switch (value) {
      case TripStatus.created:
        return 'bg-danger';
      case TripStatus.started:
      case TripStatus.ended:
        return 'bg-secondary';
      case TripStatus.driverSubmitted:
        return 'bg-warning text-dark';
      default:
        return 'bg-primary';
    }
  }
}

@Pipe({
  name: 'eventStatusBGPipe',
  standalone: true,
})
export class EventStatusBGPipe implements PipeTransform {
  transform(value: BookingStatus): string {
    // Sanitize the HTML content using DomSanitizer
    switch (value) {
      case BookingStatus.CREATED:
        return 'bg-secondary';
      case BookingStatus.PICKED_UP:
        return 'bg-primary'
      case BookingStatus.IN_TRANSIT:
        return 'bg-warning text-dark';
      case BookingStatus.REACHED_FACILITY:
        return 'bg-info';
      case BookingStatus.OUT_FOR_DELIVERY:
        return 'bg-danger';
      case BookingStatus.DELIVERED:
        return 'bg-success';
      default:
        return 'bg-secondary';
    }
  }
}
